export interface Brand {
	key: string;
	displayName: string;
	wordmarkOnLightUrl: string;
	wordmarkOnDarkUrl: string;
	markUrl: string;
	faviconUrl: string;
	/**
	 * Artwork for the login hero panel, replacing INFINIT's mark-plus-headline
	 * overlay. Optional: a brand without it keeps the INFINIT overlay, so the
	 * config can be updated after this code ships rather than in lockstep.
	 *
	 * Deliberately locale-independent — one asset serves all five languages,
	 * unlike the INFINIT overlay which has a variant per locale.
	 */
	heroHeadlineUrl?: string;
}

export interface BrandingConfig {
	brands: Record<string, Brand>;
	organizations: Record<string, string>;
}

export const EMPTY_BRANDING_CONFIG: BrandingConfig = {
	brands: {},
	organizations: {},
};

/**
 * Whether two brands are the same in every respect a surface renders.
 *
 * Not a key comparison: the cookie hint keeps a full payload for a year, so a
 * brand whose artwork was re-pointed in the config still arrives under its old
 * key. Comparing keys alone would discard the corrected payload and keep serving
 * the retired asset until the cookie happened to be rewritten.
 */
export function sameBrand(a: Brand | null, b: Brand | null): boolean {
	if (a === b) return true;
	if (!a || !b) return false;
	return (
		a.key === b.key &&
		a.displayName === b.displayName &&
		a.wordmarkOnLightUrl === b.wordmarkOnLightUrl &&
		a.wordmarkOnDarkUrl === b.wordmarkOnDarkUrl &&
		a.markUrl === b.markUrl &&
		a.faviconUrl === b.faviconUrl &&
		a.heroHeadlineUrl === b.heroHeadlineUrl
	);
}
